/** https://github.com/Kaiido/SVG2Bitmap/blob/master/SVG2Bitmap.js */
/** The original SVG2Bitmap function has be modified significantly for our usecase and also it has been converted to typescript */

/* tslint:disable */

function SVG2Bitmap(svg, receiver, params) {
    if (!params) {
        params = {};
    }
    if (!params.scale || params.scale < 0) {
        params.scale = 1;
    }
    if (!svg || !svg.nodeName) {
        console.error('Wrong arguments : should be \n SVG2Bitmap(SVGElement, function([canvasElement],[dataURL]) || IMGElement || CanvasElement [, {parameters})');
        return;
    }
    // in case user passed a framed svg
    let frame;
    // for both <iframe> and <embed>, we can try to wait for the load event
    let loadHandler = function () {
        // remove our handler
        this.removeEventListener('load', loadHandler);
        // recall the function
        SVG2Bitmap(this, receiver, params);
    };

    if (svg.nodeName === "OBJECT" || svg.nodeName === "IFRAME") {
        if (!svg.contentDocument || (svg.contentDocument.readyState === 'complete' && !svg.contentDocument.documentElement)) {
            console.error('Unable to access the svg node : make sure it comes from the same domain or that the container has finished loading');
            return;
        }
        // we can add a loadHandler to iframe elements, so we do it
        if (svg.contentDocument.readyState !== 'complete') {
            svg.addEventListener('load', loadHandler);
            return;
        }
        // keep it somewhere so we can replace it further
        frame = svg;
        svg = svg.contentDocument.documentElement;

    } else if (svg.nodeName === 'EMBED' && svg.getSVGDocument) {
        frame = svg;
        svg = svg.getSVGDocument();
        if (!svg) {
            frame.addEventListener('load', loadHandler);
            frame.onerror = function () {
                console.error('Unable to access the svg node : make sure it comes from the same domain or that the container has finished loading');
            };
            frame.src = frame.src;
            return;
        }
    }

    // the element passed is not an svg element
    if (svg.nodeName !== 'svg') {
        // get the first one in its content
        let target = svg.querySelector('svg');
        if (!target) {
            let qS = '[src*=".svg"]';
            let obj = svg.querySelector('iframe' + qS + ', embed' + qS) || svg.querySelector('object[data*=".svg"]');
            if (obj) {
                SVG2Bitmap(obj, receiver, params);
                return;
            }
            console.error('unable to access the svg node, make sure it has been appended to the document');
            return;
        } else {
            svg = target;
        }
    }

    let xlinkNS = "http://www.w3.org/1999/xlink",
        svgNS = 'http://www.w3.org/2000/svg';

    // avoid modifying the original one
    let clone = svg.cloneNode(true);
    let defs;
    let getDef = function () {
        // Do we have a `<defs>` element already ?
        defs = clone.querySelector('defs') || document.createElementNS(svgNS, 'defs');
        if (!defs.parentNode) {
            clone.insertBefore(defs, clone.firstElementChild);
        }
    };

    // an object to do some various tests
    let tester = (function () {
        // check if the canvas is tainted
        let tCanvas: any = document.createElement('canvas');
        let tCtx = tCanvas.getContext('2d');
        tCanvas.width = tCanvas.height = 2;
        let isTainted = function (canvas) {
            let tainted = false;
            tCtx.drawImage(canvas, 0, 0);
            try {
                tCanvas.toDataURL();
            } catch (e) {
                tainted = true;
                tCanvas = tCanvas.cloneNode(true);
                tCtx = tCanvas.getContext('2d');
            }
            return tainted;
        };
        let doc = document.implementation.createHTMLDocument('test');
        let base = document.createElement('base');
        doc.head.appendChild(base);
        let anchor = document.createElement('a');
        doc.body.appendChild(anchor);
        let URL = function (url, baseIRI) {
            base.href = baseIRI;
            anchor.href = url;
            return anchor;
        };
        return {
            isTainted: isTainted,
            URL: URL
        };
    })();

    // a simple flag used for some edge cases with dirty nameSpace declarations
    let cleanedNS = false;
    // The final function that will export our svgNode to our receiver

    let exportDoc = function () {
        // check if our svgNode has width and height properties set to absolute values
        // otherwise, canvas won't be able to draw it
        let bbox = frame ? frame.getBoundingClientRect() : svg.getBoundingClientRect();

        if (svg.width.baseVal.unitType !== 1) {
            clone.setAttribute('width', bbox.width);
        }

        if (svg.height.baseVal.unitType !== 1) {
            clone.setAttribute('height', bbox.height);
        }

        // serialize our node
        let svgData;
        // detect IE, that's dirty...
        var isIE = (navigator.userAgent.indexOf("MSIE") != -1);
        if (isIE) {
            // IE's XMLSerializer mess around with non-default namespaces,
            // no way to catch it ; we make the removal default then...
            let cleanNS = function (el) {
                let attr = Array.prototype.slice.call(el.attributes);

                for (let i = 0; i < attr.length; i++) {
                    let name = attr[i].name;
                    if (name.indexOf(':') > -1 && name.indexOf('xlink') < 0) {
                        el.removeAttribute(name);
                    }
                }
            };
            cleanNS(clone);
            let children = clone.querySelectorAll('*');
            for (let i = 0; i < children.length; i++) {
                cleanNS(children[i]);
            }
        }

        // we don't need the style attribute of the clone since we'll use the one from the original node
        // Thus, it can create bad things with absolutely positioned elements.
        clone.removeAttribute('style');
        svgData = (new XMLSerializer()).serializeToString(clone);
        let svgURL = 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent(svgData);
        let svgImg = new Image();

        let load_handler = function () {

            // if we set a canvas as receiver, then use it
            // otherwise create a new one
            let canvas = (receiver && receiver.nodeName === 'CANVAS') ? receiver : document.createElement('canvas');

            // keep a reference of the original node into our canvas
            canvas.originalSVG = frame || svg;

            // IE11 doesn't set a width on svg images...
            canvas.width = bbox.width * params.scale;
            canvas.height = bbox.height * params.scale;

            if (!canvas.width || !canvas.height) {
                console.error('The document is not visible and can not be rendered');
                return;
            }
            let ctx = canvas.getContext('2d');
            if (params.backgroundColor) {
                ctx.fillStyle = params.backgroundColor;
                ctx.fillRect(0, 0, canvas.width, canvas.height);
            } else {
                ctx.fillStyle = '#FFFFFF';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
            }
            let s = params.scale;
            let innerRect = frame ? svg.getBoundingClientRect(): { top: 0, left: 0 };
            try {
                if (params.full === true) {
                    //implement full snapshot scenario
                } else {
                    ctx.drawImage(this, innerRect.left, innerRect.top, this.width * s || canvas.width, this.height * s || canvas.height);
                }
            } catch (e) {
                setTimeout(load_handler.bind(this), 200);
            }
            // a default function to replace the svg element with the bitmap version
            if (!receiver) {
                receiver = function (c) {
                    let original = frame || svg;
                    original.parentNode.replaceChild(c, original);
                };
            }

            if (tester.isTainted(canvas)) {
                console.warn("Your browser has tainted the canvas.");
                if (receiver.nodeName === 'IMG') {
                    receiver.parentNode.replaceChild(canvas, receiver);
                } else {
                    // make the canvas looks like the svg
                    canvas.setAttribute('style', getSVGStyles(canvas));
                    // a container element
                    if (receiver !== canvas && receiver.appendChild) {
                        receiver.appendChild(canvas);
                    }
                    // if we did set a function
                    else if (typeof receiver === 'function') {
                        receiver(canvas, null);
                    }
                }
                return;
            }

            if (receiver.nodeName === 'IMG') {
                // make the img looks like the svg
                receiver.setAttribute('style', getSVGStyles(receiver));
                receiver.src = canvas.toDataURL(params.type, params.quality);
            } else {
                // make the canvas looks like the svg
                canvas.setAttribute('style', getSVGStyles(canvas));
                // a container element
                if (receiver !== canvas && receiver.appendChild) {
                    receiver.appendChild(canvas);
                }
                // if we did set a function
                else if (typeof receiver === 'function') {
                    receiver(canvas, canvas.toDataURL(params.type, params.quality));
                }
            }
        };

        let error_handler = function (e) {
            console.error("Couldn't export svg, please check that the svgElement passed is a valid svg document.");
            return;
        };

        svgImg.onload = load_handler;
        svgImg.onerror = error_handler;
        svgImg.src = svgURL;
    };
    // get all the rules applied to our svg elements
    let parseStyles = function () {
        let cssIRIs = [],
            styleSheets = [];
        let i;
        // get the stylesheets of the document (ownerDocument in case svg is in <iframe> or <object>)
        let docStyles = svg.ownerDocument.styleSheets;

        // transform the live StyleSheetList to an array to avoid endless loop
        for (i = 0; i < docStyles.length; i++) {
            styleSheets.push(docStyles[i]);
        }

        if (styleSheets.length) {
            getDef();
            svg.matches = svg.matches || svg.webkitMatchesSelector || svg.mozMatchesSelector || svg.msMatchesSelector || svg.oMatchesSelector;
        }

        // iterate through all document's stylesheets
        for (i = 0; i < styleSheets.length; i++) {
            let currentStyle = styleSheets[i]

            let rules;
            try {
                rules = currentStyle.cssRules;
            } catch (e) {
                continue;
            }
            // create a new style element
            let style = document.createElement('style');
            // some stylesheets can't be accessed and will throw a security error
            let l = rules && rules.length;
            // iterate through each cssRules of this stylesheet
            for (let j = 0; j < l; j++) {
                // get the selector of this cssRules
                let selector = rules[j].selectorText;
                // probably an external stylesheet we can't access
                if (!selector) {
                    continue;
                }

                // is it our svg node or one of its children ?
                if ((svg.matches && svg.matches(selector)) || svg.querySelector(selector)) {
                    let cssText = rules[j].cssText;
                    let reg = new RegExp(/url\((.*?)\)/g);
                    let matched = [];
                    while ((matched = reg.exec(cssText)) !== null) {
                        let ext = matched[1].replace(/\"/g, '');
                        let href = currentStyle.href || location.href;
                        cssIRIs.push([ext, href]);
                        let a = tester.URL(ext, href);
                        let iri = (href === location.href && ext.indexOf('.svg') < 0) ? a.hash : a.href.substring(a.href.lastIndexOf('/') + 1);
                        let newId = '#' + iri.replace(/\//g, '_').replace(/\./g, '_').replace('#', '_');
                        cssText = cssText.replace(ext, newId);
                    }
                    // append it to our <style> node
                    style.innerHTML += cssText + '\n';
                }
            }
            // if we got some rules
            if (style.innerHTML) {
                // append the style node to the clone's defs
                defs.appendChild(style);
            }
        }
        // small hack to avoid border and margins being applied inside the <img>
        let s = clone.style;
        s.border = s.padding = s.margin = 0;
        s.transform = 'initial';
        parseXlinks(cssIRIs);
    };

    let getSVGStyles = function (node) {
        // create a testing element
        let dest = node.cloneNode(true);

        // insert the clone in the document if the parentNode is not a Document.
        if (!svg.parentNode.documentElement) {
            svg.parentNode.insertBefore(dest, svg);
        } else {
            svg.parentNode.documentElement.appendChild(dest);
        }

        // get the destination's computed styles
        let dest_comp = getComputedStyle(dest);
        // get the iframe or svg's computed styles
        let svg_comp = getComputedStyle(frame || svg);
        let mods = "";
        for (let i = 0; i < svg_comp.length; i++) {
            // the width and height are set from bbox so we should not need this
            // also, this allows us to scale the export
            if (svg_comp[i] === 'width' || svg_comp[i] === 'height') {
                continue;
            }
            // different styles
            if (svg_comp[svg_comp[i]] !== dest_comp[svg_comp[i]]) {
                // append it
                mods += svg_comp[i] + ':' + svg_comp[svg_comp[i]] + ';';
            }
        }
        // remove our testing element
        dest.parentNode.removeChild(dest);
        return mods;
    };

    let parseImages = function () {

        let images = clone.querySelectorAll('image'),
            total = images.length,
            encoded = 0,
            i;

        // if there is no <image> element
        if (total === 0) {
            exportDoc();
            return;
        }
        // get the already appended images bounding rect
        let originalImages = [];
        let oImg = svg.querySelectorAll('image');
        for (i = 0; i < images.length; i++) {
            // that should be the same ones but better to check
            if (oImg[i] && oImg[i].isEqualNode(images[i])) {
                originalImages.push(oImg[i]);
                continue;
            } else {
                let found = null;
                for (let j = 0; j < oImg.length; j++) {
                    if (oImg[j].isEqualNode(images[i])) {
                        found = oImg[j];
                        break;
                    }
                }
                originalImages.push(found);
            }
        }

        // that's quite a bit of lines, but it saves a lot of computations if we do treat large images
        let preserveAspectRatio = function (source, destination, userString) {

            let srcWidth = source.width,
                srcHeight = source.height,
                destinationW = destination.width,
                destinationH = destination.height;

            // we should keep the whole source
            let aRMeet = function (args) {

                let srcRatio = (srcHeight / srcWidth),
                    destRatio = (destinationH / destinationW),

                    resultWidth = destRatio > srcRatio ? destinationW : destinationH / srcRatio,
                    resultHeight = destRatio > srcRatio ? destinationW * srcRatio : destinationH;

                let getPos = function (arg, res, dest) {

                    let max = Math.max(res, dest),
                        min = Math.min(res, dest);

                    switch (arg) {
                        case 'Min': return 0;
                        case 'Mid': return (max - min) / 2;
                        case 'Max': return max - min;
                        default: return 'invalid';
                    }
                };

                let obj = [
                    returnedImg,
                    0,
                    0,
                    srcWidth,
                    srcHeight,
                    getPos(args[0], resultWidth, destinationW),
                    getPos(args[1], resultHeight, destinationH),
                    resultWidth,
                    resultHeight
                ];

                if (obj[5] === 'invalid' || obj[6] === 'invalid') {
                    return default_obj;
                }

                return obj;
            };

            // we should slice the larger part
            let aRSlice = function (args) {

                let resultWidth, resultHeight;

                let a = function () {
                    resultWidth = destinationW;
                    resultHeight = srcHeight * destinationW / srcWidth;
                };

                let b = function () {
                    resultWidth = srcWidth * destinationH / srcHeight;
                    resultHeight = destinationH;
                };

                if (destinationW > destinationH) {
                    a();
                    if (destinationH > resultHeight) {
                        b();
                    }
                } else if (destinationW === destinationH) {
                    if (srcWidth > srcHeight) {
                        b();
                    } else {
                        a();
                    }
                } else {
                    b();
                    if (destinationW > resultWidth) {
                        a();
                    }
                }

                let getPos = function (arg, res, dest, src) {
                    switch (arg) {
                        case 'Min': return 0;
                        case 'Mid': return (res - dest) / 2 * src / res;
                        case 'Max': return (res - dest) * src / res;
                        default: return 'invalid';
                    }
                };

                let x: any = getPos(args[0], resultWidth, destinationW, srcWidth);
                let y: any = getPos(args[1], resultHeight, destinationH, srcHeight);

                let obj = [
                    returnedImg,
                    x,
                    y,
                    srcWidth - x,
                    srcHeight - y,
                    0,
                    0,
                    resultWidth - (x * (resultWidth / srcWidth)),
                    resultHeight - (y * (resultHeight / srcHeight)),
                ];

                if (obj[1] === 'invalid' || obj[2] === 'invalid') {
                    return default_obj;
                }

                return obj;
            };

            // check if the object passed was drawable over a canvas
            let returnedImg = source.nodeName === 'IMG' || source.nodeName === 'VIDEO' || source.nodeName === 'CANVAS' ? source : null;

            // if an invalid string or none is set as the preserveAspectRatio, this should be considered as "xMidYMid meet"
            let default_obj = aRMeet(['Mid', 'Mid']);

            if (!userString) {
                return default_obj;
            } else {

                let args = userString.trim().split(' '),
                    minMidMax = args[0].replace('x', '').split('Y');

                switch (args[args.length - 1]) {
                    case "meet": return aRMeet(minMidMax);
                    case "slice": return aRSlice(minMidMax);
                    default: return default_obj;
                }

            }
        };

        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');

        // some UAs don't fire a load event on <image> element
        let loader = function (url) {
            let img = new Image();
            img.onload = function () {
                // that was the last one
                if (++encoded === total) {
                    exportDoc();
                }
            };
            img.src = url;
        };


        // convert an external bitmap image to a dataURL
        let toDataURL = function (image, original) {

            let img = new Image();

            let error_handler = function () {
                console.warn('failed to load an image at : ', img.src);
                if (!params.keepImageHolder) {
                    image.parentNode.removeChild(image);
                }
                if (--total === encoded) {
                    exportDoc();
                }

            };

            if (!params.noCORS) {
                img.crossOrigin = 'Anonymous';
            }

            img.onload = function () {
                let attr, rect;
                if (original) {
                    attr = image.getAttribute('preserveAspectRatio');
                    rect = original.getBoundingClientRect();
                }
                // if the image is scaled down in the image
                if (original && rect && (rect.width * params.scale < this['width'] || rect.height * params.scale < this['height'])) {
                    // set the canvas size to the <image>'s one
                    canvas.width = rect.width * params.scale;
                    canvas.height = rect.height * params.scale;
                    // draw only what is needed (About 3000ms saved on 5M images !)
                    let ar = preserveAspectRatio(this, canvas, attr);
                    ctx.drawImage.apply(ctx, ar);

                } else {
                    let _this:any = this;
                    canvas.width = this['width'];
                    canvas.height = this['height'];
                    ctx.drawImage(_this, 0, 0);

                }

                if (tester.isTainted(canvas)) {
                    error_handler();
                    return;
                }

                let dataURL = canvas.toDataURL();
                image.setAttributeNS(xlinkNS, 'href', dataURL);
                loader(dataURL);

            };

            // No CORS set in the response
            img.onerror = function () {
                // save the src
                let oldSrc = this['src'];
                // there is an other problem
                this.onerror = error_handler;
                // remove the crossorigin attribute
                this.removeAttribute('crossorigin');
                // retry
                this['src'] = '';
                this['src'] = oldSrc;
            };

            // load our external image into our img
            img.src = image.getAttributeNS(xlinkNS, 'href');
        };

        // get an external svg doc to data String
        let parseFromUrl = function (url, element) {
            let xhr = new XMLHttpRequest();
            xhr.onload = function () {

                if (this['status'] === 200) {

                    let response = this['responseText'] || this['response'];
                    let dataUrl = 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent('<svg' + response.split('<svg')[1]);
                    element.setAttributeNS(xlinkNS, 'href', dataUrl);
                    loader(dataUrl);

                }
                // request failed with xhr, try as an <img>
                else {
                    toDataURL(element, null);
                }

            };
            xhr.onerror = function () {
                toDataURL(element, null);
            };
            // IE will throw an error if we try to get a file from an other domain
            try {
                xhr.open('GET', url);
            } catch (e) {
                toDataURL(element, null);
                return;
            }
            xhr.send();
        };

        // loop through all our <images> elements
        for (i = 0; i < images.length; i++) {

            let href = images[i].getAttributeNS(xlinkNS, 'href');
            // check if the image is external
            if (href && href.indexOf('data:image') < 0) {
                // if it points to another svg element
                if (href.indexOf('.svg') > 0) {
                    parseFromUrl(href, images[i]);
                } else {
                    // a pixel image
                    toDataURL(images[i], originalImages[i]);
                }
            }
            // else increment our counter
            else if (++encoded === total) {
                exportDoc();
                return;
            }
        }
    };

    let parseXlinks = function (css) {

        let i;
        let elemToParse = 0;
        let docsToFetch = 0;
        // our actual doc
        let current_doc = {
            href: location.href.replace(location.hash, '').replace(/#/g, ''),
            pathname: location.pathname,
            filename: '',
            innerElements: [],
            parsedElements: [],
            doc: svg.ownerDocument,
            base: location.href.replace(location.hash, '').replace(/#/g, '')
        };
        // an array for our external documents
        let documents = [current_doc];

        let nsSelector_support = (function () {
            // create a test element
            let test = document.createElementNS(svgNS, 'use');
            // set its href attribute to something that should be found
            test.setAttributeNS(xlinkNS, 'href', '#__#');
            // append it to our document
            clone.appendChild(test);
            // if querySelector returns null then the selector is not supported
            let supported = !!clone.querySelector('[*|href*="#"]');
            // the test is done, remove the element
            clone.removeChild(test);
            return supported;
        })();

        let queryXlinks = function (el) {
            return nsSelector_support ? el.querySelectorAll('[*|href*="#"]') :
                // if the selector is not supported
                (function () {
                    let arr = [];
                    let children = el.querySelectorAll('*');
                    for (i = 0; i < children.length; i++) {
                        // search the xlink:href attribute
                        let xl_attr = children[i].getAttributeNS(xlinkNS, 'href');
                        // we only want the ones that refer to elements
                        if (xl_attr && xl_attr.indexOf('#') > -1) {
                            arr.push(children[i]);
                        }
                    }
                    return arr;
                })();
        };

        let getURLs = function (el) {
            // the list of all attributes that can have a <funciri> (url()) as value
            let url_attrs = ["style", "clip-path", "src", "cursor", "fill", "filter", "marker", "marker-start", "marker-mid", "marker-end", "mask", "stroke"];
            // build our selector string
            let urlSelector = '[*|' + url_attrs.join('*="url"], *[*|') + '*="url"]';

            let list = el.querySelectorAll(urlSelector);
            return list;
        };

        let getXternalAttributes = function (el, doc) {

            let externals = [];

            let ext_attr = function (ele, type): any {
                let that: any = {};
                that.element = ele;
                that.type = type;
                that.attributes = [];
                that.requestedElements = [];
                that.parentDoc = doc;
                let att;
                if (type === 'xl') {

                    att = ele.attributes['xlink:href'];
                    if (!att) {
                        let href = ele.attributes.href;
                        if (href && href.namespaceURI && href.namespaceURI.indexOf('xlink') > -1) {
                            att = href;
                        } else {
                            return false;
                        }
                    }
                    that.attributes.push(att);
                    that.requestedElements.push(att.value);

                } else {

                    att = ele.attributes;
                    for (let j = 0; j < att.length; j++) {
                        let reg = new RegExp(/url\((.*?)\)/g);
                        let matched = [];
                        while ((matched = reg.exec(att[j].value)) !== null) {
                            that.attributes.push(att[j]);
                            that.requestedElements.push(matched[1].replace(/"/g, ''));
                        }
                    }
                }
                return that;
            };

            let xl = queryXlinks(el);

            let url = getURLs(el);

            let i;

            let att;

            for (i = 0; i < xl.length; i++) {
                att = ext_attr(xl[i], 'xl');
                if (!att) {
                    continue;
                }
                externals.push(att);
                att = null;
            }

            for (i = 0; i < url.length; i++) {
                att = ext_attr(url[i], 'url');
                if (!att) {
                    continue;
                }
                externals.push(att);
                att = null;
            }

            let self_attrs = el.attributes;

            for (i = 0; i < self_attrs.length; i++) {
                let self_attr = self_attrs[i];
                if (self_attr.name === 'xlink:href') {
                    externals.push(ext_attr(el, 'xl'));
                } else {
                    let matched = self_attr.value.match(/url\((.*)\)/);
                    if (matched && matched.length > 1) {
                        externals.push(ext_attr(el, 'url'));
                    }
                }
            }



            return externals;
        };

        let changeImagesHref = function (elem, base) {
            let images = elem.querySelectorAll('image');
            for (let i = 0; i < images.length; i++) {
                let href = images[i].getAttributeNS(xlinkNS, 'href');
                let newHref = tester.URL(href, base).href;
                if (href !== newHref) {
                    images[i].setAttributeNS(xlinkNS, 'href', newHref);
                }
            }
        };

        let getInnerElements = function () {
            let i;
            for (i = 0; i < documents.length; i++) {
                let doc = documents[i];
                if (!doc.doc) {
                    continue;
                }
                let inners = doc.innerElements;
                if (inners.length === doc.parsedElements.length) {
                    continue;
                }
                let j;
                for (j = 0; j < inners.length; j++) {
                    let node = doc.doc.getElementById(inners[j]);
                    if (!node) {
                        console.warn("Couldn't find this element", inners[j]);
                        elemToParse--;
                        continue;
                    }
                    let clone = node.cloneNode(true);
                    clone.id = doc.filename + '_' + inners[j];

                    changeImagesHref(clone, doc.base);

                    defs.appendChild(clone);
                    parse_attributes(getXternalAttributes(clone, doc));
                    doc.parsedElements.push(inners[j]);
                    elemToParse--;
                }
            }

            if (!docsToFetch && !elemToParse) {
                parseImages();
            }
        };

        // fetch the external documents
        let fetchExternalDoc = function (ext_doc) {
            let url = ext_doc.href;
            // create a new request
            let xhr = new XMLHttpRequest();

            xhr.onload = function () {
                // everything went fine
                if (this['status'] === 200) {
                    let response = this['responseText'] || this['response'];
                    if (!response) {
                        return;
                    }
                    try {
                        ext_doc.doc = new DOMParser().parseFromString(response, 'text/html');
                    } catch (ie) {
                        ext_doc.doc = document.implementation.createHTMLDocument(ext_doc.filename);
                        ext_doc.doc.body.innerHTML = response;
                    }

                    ext_doc.base = url;
                } else {
                    ext_doc.doc = null;
                    elemToParse -= ext_doc.innerElements.length;
                    console.warn('could not load this external document :', url, '\n' +
                        'Those elements are lost : ', ext_doc.innerElements.join(' , '));
                }
                // In case we were the last one
                if (!--docsToFetch) {
                    getInnerElements();
                }
            };
            xhr.onerror = function (e) {
                ext_doc.doc = null;
                elemToParse -= ext_doc.innerElements.length;
                console.warn('could not load this external document', url);
                console.warn('Those elements are lost : ', ext_doc.innerElements.join(' , '));
                if (!--docsToFetch) {
                    getInnerElements();
                }
            };
            xhr.open('GET', url);
            xhr.send();
        };

        let append_doc = function (iri, doc) {
            let a = tester.URL(iri, doc.base);
            let original_filename = a.href.substring(a.href.lastIndexOf('/') + 1).replace(a.hash, '');
            let filename = original_filename.replace(/\./g, '_');
            let hash = a.hash.replace('#', '');
            let href = a.href.replace(a.hash, '');
            let newId = filename + '_' + hash;

            for (let i = 0; i < documents.length; i++) {
                let docI = documents[i];
                // already in the list
                if (docI.href === href) {
                    // not an external doc
                    if (i === 0) {
                        if (clone.getElementById(hash)) {
                            return hash;
                        } else {
                            newId = '_' + hash;
                        }
                    }
                    // but not in the innerElements
                    if (docI.innerElements.indexOf(hash) < 0) {
                        // this would mean we failed to load it
                        if (docI.doc !== null) {
                            elemToParse++;
                        } else {
                            console.warn('this element is also lost ', hash);
                        }
                        docI.innerElements.push(hash);
                        return newId;
                    }
                    // someone else already asked for this element
                    else {
                        return newId;
                    }
                }
            }

            elemToParse++;
            docsToFetch++;

            let that: any = {
                href: href,
                filename: filename,
                innerElements: [hash],
                parsedElements: [],
            };

            // add it to our array
            documents.push(that);
            fetchExternalDoc(that);
            return newId;

        };

        let parse_attributes = function (external_attributes) {

            if (external_attributes.length && !defs) {
                getDef();
            }

            let i, j;
            for (i = 0; i < external_attributes.length; i++) {

                let ext = external_attributes[i];

                for (j = 0; j < ext.requestedElements.length; j++) {

                    let requested = ext.requestedElements[j];
                    let newId = '#' + append_doc(requested, ext.parentDoc);
                    let attr = ext.attributes[j];
                    let newValue = attr.value.replace(requested, newId);
                    // fixes a strange UpperCase bug in Edge
                    let name = (attr.name.toUpperCase() === attr.name) ? attr.name.toLowerCase() : attr.name;
                    ext.element.setAttribute(name, newValue);

                }

            }
        };

        for (i = 0; i < css.length; i++) {
            append_doc(css[i][0], {
                base: css[i][1]
            });
        }

        parse_attributes(getXternalAttributes(clone, documents[0]));

        if (!docsToFetch) {
            if (!elemToParse) {
                parseImages();
            } else {
                getInnerElements();
            }
        }
    };

    parseStyles();
}

// Convert dataURL to Blob
function dataURLtoBlob(dataurl) {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

// Convert base64 to Blob
function base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 1024;
    let byteCharacters = atob(base64Data);
    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);
        let bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

export { SVG2Bitmap, dataURLtoBlob, base64toBlob };


// WEBPACK FOOTER //
// ./src/common/vca-joint/svg-export.ts